<template>
    <section>
        <form class="container mt-8">
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Title</label>
                        <input type="text" class="form-control" v-model="title"  >
                    </div>
                    <div class="form-group">
                        <label for="exampleInputPassword1">Description</label>
                        <textarea type="text" class="form-control" v-model="description" ></textarea>
                    </div>
                </div>
            </div> 
            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label for="exampleInputPassword1">Missions</label>
    
                        <div v-for="(missionsInput, index) in missionsInputs" :key="index" class="align-items-baseline d-flex justify-content-between missionList">
                            <input type="text" class="form-control w-75 mt-2" v-model="missionsInput.value">
                            <i class="fa-solid fa-trash icons w-15" @click="DeleteMission(index)" v-if="missionsInputs.length > 1"></i>
                        </div>
    
                        <div class="container d-flex justify-content-between  mb-5 ">
                            <i class="fa-solid fa-plus icons mt-2" @click="AddMission" ></i>
                        </div>
                    </div>
                </div>
    
                <div class="col">
                    <div class="form-group">
                        <label for="exampleInputPassword1">Profil recherché</label>
    
                        <div v-for="(profileInput, index) in profileInputs" :key="index" class="align-items-baseline d-flex justify-content-between profileList">
                            <input type="text" class="form-control w-75 mt-2" v-model="profileInput.value">
                            <i class="fa-solid fa-trash icons w-15" @click="DeleteProfile(index)" v-if="profileInputs.length > 1"></i>
                        </div>
                        <div class="container d-flex justify-content-between  mb-5 ">
                            <i class="fa-solid fa-plus icons mt-2" @click="AddProfile" ></i>
                        </div>
                    </div>
                </div>
            </div>
            <button type="submit" class="btn  btn-light me-2" @click.prevent="addJob" >Enregistrer</button>
            <button type="submit" class="btn btn-light4 me-2" @click.prevent="$emit('cancel' , {})" >Annuler</button>
        </form>
    </section>
    
    </template>
    
    <script>
    import axios from 'axios'
import APIs from "@/../config";
    export default {
        name: "AddPost",
        data() {
            return {
                title : "" ,
                description : "" , 
                missionsInputs: [
                    {value: ""}
                ],
                profileInputs:[
                    {value:""}
                ]
            };
        },
        props : {
            post : Object
        },
        created(){
          this.title = this.post.name
          this.description = this.post.description
          this.missionsInputs = this.post.mission
          this.profileInputs = this.post.profile
        },
        methods : {
            addJob(){
                var get_token = localStorage.getItem('token')
                var user_id = localStorage.getItem('user_id')
                axios.put(`${APIs.API_URL}/job/${user_id}/${this.post._id}`,{
                    'name' : this.title ,
                    'description' : this.description , 
                    'mission' : this.missionsInputs,
                    'profile' : this.profileInputs , 
                }, {
                    headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${get_token}`
                    }
                })
                .then(() => {
                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'success',
                        title: "ajoutée",
                        showConfirmButton: false,
                        timer: 1500
                    });
                    this.$emit("refresh")
                })
                .catch( (error) => {
                    this.$swal.fire({
                        position: 'top-end',
                        icon: 'error',
                        title: error.response.data.error,
                        showConfirmButton: false,
                        timer: 1500
                    });
                });
            
            },
            AddMission() {
                this.missionsInputs.push({value: ""})
            },
            DeleteMission(index) {
                this.missionsInputs.splice(index, 1)
            },
            AddProfile() {
                this.profileInputs.push({value: ""})
            },
            DeleteProfile(index) {
                this.profileInputs.splice(index, 1)
            },
        }
    }
    
    </script>
    
    <style scoped>
    .title{
        color:white;
    }
    
    .icons{
        background: #A68D5B;
        color: white;
        width: 20%;
        height: 35px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 7px;
        cursor:pointer;
        margin-left: -20px;
        
    }
    :hover.icons{
        position:relative;
        bottom:1px;
    }
    
    .btn-light{
        background-color: black;
        color: white;
    }
    
    
    </style>
    
    
    